import { BaseInput } from '@app/components/common/inputs/BaseInput/BaseInput';
import { BaseSelect } from '@app/components/common/selects/BaseSelect/BaseSelect';
import { DropdownOption } from '@app/models/DropdownOption';
import { Row, Col, Form, Select, Radio, RadioChangeEvent } from 'antd';
import { useState } from 'react';

type CustomerBusinessInfoProps = {
  hasRegistered: boolean;
  isBusiness: boolean;
  setHasRegistered: (value: boolean) => void;
  setIsBusiness: (value: boolean) => void;
  hasBrOptions: DropdownOption[];
  businessTypeOptions: DropdownOption[];
  companyTypeOptions: DropdownOption[];
  mode: 'view' | 'edit' | 'create';
};

export const CustomerBusinessInfo: React.FC<CustomerBusinessInfoProps> = (props) => {
  const readOnly = props.mode == 'view';
  const requiredMark = !readOnly;
  return (
    <>
      <Row gutter={16}>
        <Col xs={24} md={24} lg={12}>
          <Form.Item name="business_type" label="Account Type" rules={[{ required: requiredMark }]}>
            {readOnly ? (
              <BaseInput readOnly={readOnly} />
            ) : (
              <BaseSelect
                options={props.businessTypeOptions}
                onChange={(e: any) => {
                  props.setIsBusiness(e == 'BUSINESS');
                }}
              ></BaseSelect>
            )}
          </Form.Item>
        </Col>
      </Row>
      {props.isBusiness && (
        <>
          <Row gutter={16}>
            <Col xs={24} md={24} lg={12}>
              <Form.Item name="business_name" label="Business Name" rules={[{ required: requiredMark }]}>
                <BaseInput readOnly={readOnly} />
              </Form.Item>
            </Col>

            <Col xs={24} md={24} lg={12}>
              <Form.Item name="business_address" label="Business Address" rules={[{ required: requiredMark }]}>
                <BaseInput readOnly={readOnly} />
              </Form.Item>
            </Col>

            <Col xs={24} md={24} lg={12}>
              <Form.Item name="company_type" label="Company Type" rules={[{ required: requiredMark }]}>
                {readOnly ? <BaseInput readOnly={readOnly} /> : <Select options={props.companyTypeOptions}></Select>}
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} md={24} lg={12}>
              <Form.Item name="has_br" label="Business Registered?" rules={[{ required: requiredMark }]}>
                {readOnly ? (
                  <BaseInput readOnly={readOnly} />
                ) : (
                  <Radio.Group
                    onChange={(e: RadioChangeEvent) => {
                      props.setHasRegistered(e?.target?.value == 'YES');
                    }}
                    options={props.hasBrOptions}
                  ></Radio.Group>
                )}
              </Form.Item>
            </Col>
            {props.hasRegistered && (
              <Col xs={24} md={24} lg={12}>
                <Form.Item name="business_reg_no" label="Business Registration No" rules={[{ required: requiredMark }]}>
                  <BaseInput readOnly={readOnly} />
                </Form.Item>
              </Col>
            )}
          </Row>
        </>
      )}
    </>
  );
};
